import { render, staticRenderFns } from "./PsHomeGroupsInPhase.vue?vue&type=template&id=1c6acfe4&scoped=true&"
import script from "./PsHomeGroupsInPhase.vue?vue&type=script&lang=js&"
export * from "./PsHomeGroupsInPhase.vue?vue&type=script&lang=js&"
import style0 from "./PsHomeGroupsInPhase.vue?vue&type=style&index=0&id=1c6acfe4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6acfe4",
  null
  
)

export default component.exports